import { useNavigate, useParams } from 'react-router-dom'

import StepUpsertModal from 'modules/processes/components/ProcessSettings/Steps/StepUpsertModal'
import { useProcessContext } from 'modules/processes/pages/Process/ProcessRootPage'

const EditStepModalPage = () => {
  const navigate = useNavigate()
  const { stepId } = useParams()
  const { process } = useProcessContext()

  const onClose = () => {
    navigate(-1)
  }

  if (!process) return null

  return (
    <StepUpsertModal
      stepId={Number(stepId)}
      onClose={onClose}
      steps={process.steps}
      processId={process.id}
    />
  )
}

export default EditStepModalPage
